module.exports = __webpack_public_path__ + "media/dashboard/assets/images/lia-avatar-5b4f049a8042ca14b991aa50bfb4c4da.png";